import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandEloomi(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <rect x="2.4" y="2.4" width="19.2" height="19.2" rx="4" fill="#002BC1" />
      <path
        d="M15.246 7.8c-2.172 0-3.954 1.83-3.954 4.125 0 2.294 1.757 4.124 3.954 4.124 2.196 0 3.954-1.83 3.954-4.124-.025-2.27-1.782-4.125-3.954-4.125Zm1.855 6.004c-1 1.171-2.71 1.171-3.71 0-.928-1.05-.928-2.71 0-3.783 1-1.172 2.71-1.172 3.71 0 .903 1.074.903 2.733 0 3.783Z"
        fill="#fff"
      />
      <path
        opacity=".15"
        d="M12.683 12.047a2.957 2.957 0 0 1 .44-1.684 9.674 9.674 0 0 0-1.001-1.001 4.23 4.23 0 0 0-.684 1.318c.025 0 .391 1.367 1.245 1.367Z"
        fill="url(#eloomi-a)"
      />
      <path
        d="M8.754 7.8C6.58 7.8 4.8 9.63 4.8 11.925c0 2.294 1.757 4.124 3.954 4.124 2.196 0 3.954-1.83 3.954-4.124-.025-2.27-1.782-4.125-3.954-4.125Zm1.855 6.004c-1.001 1.171-2.71 1.171-3.71 0-.928-1.05-.928-2.71 0-3.783 1-1.172 2.709-1.172 3.71 0 .927 1.074.927 2.733 0 3.783Z"
        fill="#fff"
      />
      <path
        opacity=".2"
        d="M12 14.268a4.214 4.214 0 0 1-.708-2.343c0 .683-.22 1.366-.684 1.879a2.28 2.28 0 0 1-.659.537c.122.366.342.757.684 1.171.537-.292 1-.707 1.366-1.244Z"
        fill="url(#eloomi-b)"
      />
      <defs>
        <linearGradient
          id="eloomi-a"
          x1="11.711"
          y1="11.42"
          x2="12.974"
          y2="10.157"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="eloomi-b"
          x1="9.865"
          y1="14.132"
          x2="11.835"
          y2="13.416"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".5" stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
